import { Component } from '@angular/core';

@Component({
    selector: 'gh-category-layout',
    templateUrl: 'category-layout.component.html',
    standalone: false
})

export class CategoryLayoutComponent {

  constructor() { }

}
